import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Position,
  Tooltip,
  Button,
  ButtonGroup,
  Divider,
  Icon,
  Card,
} from '@blueprintjs/core';
import SimpleBar from 'simplebar-react';
import OnlineCountChart from '../Components/OnlineCountChart';
import RageCH from '../Assets/Images/ch.png';
import RageEU from '../Assets/Images/eu.png';
import ItemInfo from '../Components/ItemInfo';
import SroFilterMenuDialog from '../Components/SroFilterMenuDialog';

export default class Home extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="row">
          <div className="col-sm-6">
            <h3
              className="display-4 font-italic mb-4"
              style={{ fontSize: '2.5rem' }}
            >
              Last World Online
            </h3>
          </div>

          <div className="col-sm-6 text-center">
            <div className="row">
              {new Array(3).fill(0).map((Arr, ArrIndex) => (
                <div className="col-sm-4" key={ArrIndex}>
                  <Button
                    fill
                    className={[
                      `text-${['success', 'success', 'white'][ArrIndex]}`,
                      'mb-2',
                    ]}
                    minimal={ArrIndex === 2 ? false : true}
                    intent={ArrIndex === 2 ? 'danger' : 'none'}
                  >
                    <Icon
                      icon={ArrIndex === 2 ? 'warning-sign' : 'record'}
                      className={[
                        `text-${['success', 'success', 'danger'][ArrIndex]}`,
                        'mr-1',
                      ]}
                    />
                    <span>
                      {['Gateway', 'Agent', 'Download'][ArrIndex]} Server
                    </span>
                  </Button>

                  <ButtonGroup fill className="mb-4">
                    {ArrIndex < 2 ? (
                      <Button intent="success" icon="play" disabled={true} />
                    ) : (
                      <Tooltip content="Start Server" position={Position.TOP}>
                        <Button intent="success" icon="play" />
                      </Tooltip>
                    )}

                    {ArrIndex > 1 ? (
                      <Button intent="warning" icon="reset" disabled={true} />
                    ) : (
                      <Tooltip content="Restart Server" position={Position.TOP}>
                        <Button intent="warning" icon="reset" />
                      </Tooltip>
                    )}

                    {ArrIndex > 1 ? (
                      <Button intent="danger" icon="stop" disabled={true} />
                    ) : (
                      <Tooltip content="Stop Server" position={Position.TOP}>
                        <Button intent="danger" icon="stop" />
                      </Tooltip>
                    )}
                  </ButtonGroup>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-6 mb-4">
            <Card interactive={true}>
              <h3 className="display-4 mb-4" style={{ fontSize: '1.2rem' }}>
                Active License: Standart-II Package
              </h3>

              <div className="row">
                <div className="col-sm-6">
                  <h6>
                    <a href="/" onClick={(e) => e.preventDefault()}>
                      Remaining Days:
                    </a>
                  </h6>
                </div>
                <div className="col-sm-6 text-right">50 Days</div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <h6>
                    <a href="/" onClick={(e) => e.preventDefault()}>
                      Expire Date:
                    </a>
                  </h6>
                </div>
                <div className="col-sm-6 text-right">19.02.2020</div>
              </div>

              <div
                className="bp3-progress-bar bp3-intent-success bp3-no-animation mt-2 mb-4"
                style={{ height: '20px' }}
              >
                <div
                  className="bp3-progress-meter"
                  style={{ width: '38%' }}
                ></div>
              </div>

              <Divider className="mb-3" />

              <div className="row">
                <div className="col-sm-6">
                  <h6>
                    <a href="/" onClick={(e) => e.preventDefault()}>
                      Created Date:
                    </a>
                  </h6>
                </div>
                <div className="col-sm-6 text-right">01.01.2020</div>
              </div>
            </Card>
          </div>

          <div className="col-sm-6 mb-4">
            <OnlineCountChart UpdateInterval={650} />
          </div>
        </div>

        <div className="row">
          <div className="col mb-4">
            <h3 className="display-4 mb-2" style={{ fontSize: '1rem' }}>
              Chat
            </h3>

            <SimpleBar style={{ maxHeight: 280 }}>
              <ul className="list-group HomeList Chat GlobalChat">
                {[
                  {
                    Player: 'GoldCeo',
                    Time: '23:50',
                    Message:
                      'Sell Chinese and European Account,please contact www.GOLDCEO.com--58',
                  },
                  {
                    Player: 'GK_',
                    Time: '23:50',
                    Message:
                      '<<WWW.gkplayer.COM>>.<<WWW.gkplayer.COM>>.<<WWW.gkplayer.COM>>1000M=13.30$-42',
                  },
                  {
                    Player: 'Merlin',
                    Time: '23:50',
                    Message: `WTS < Paradise Jewel Ring > Weapon  elixir 30 pm me`,
                    Item: [6, 19, 298347],
                  },
                  {
                    Player: 'Sharpknife',
                    Time: '23:50',
                    Message:
                      'THX HandOfGod for 2 Bil Silkroad Online Giveaway :) Really nice :)',
                  },
                  {
                    Player: 'WesleySneijder',
                    Time: '23:50',
                    Message: 'WTB IMMO NEED 3Pices',
                  },
                  {
                    Player: 'Nozich',
                    Time: '23:50',
                    Message: 'WTS SILKS PM ME!!!! 1silk = 10m',
                  },
                  {
                    Player: 'edjka1985',
                    Time: '23:50',
                    Message:
                      'Lets try my Blade fuse to +13 xD twitch.tv/edjka1985',
                  },
                  {
                    Player: 'Smsm_',
                    Time: '23:50',
                    Message:
                      'WTS Glive +2 Fb max GS 3x60% 1x80% pm me fast and offer or wTT for ?',
                  },
                ].map((Global, GlobalIndex) => (
                  <li
                    className="list-group-item d-flex align-items-center"
                    key={GlobalIndex}
                  >
                    <span className="badge badge-light">{Global.Time}</span>

                    <span className="ChatMessage">
                      <NavLink
                        to={`/Players/${Global.Player}`}
                        className="text-white"
                      >
                        {Global.Player}
                      </NavLink>

                      {': '}

                      {Global.Item ? (
                        <span className="d-inline">
                          {Global.Message.substr(0, Global.Item[0])}

                          <Tooltip content={<ItemInfo />}>
                            <u>
                              {Global.Message.substr(
                                Global.Item[0],
                                Global.Item[1]
                              )}
                            </u>
                          </Tooltip>

                          {Global.Message.substr(
                            Global.Item[0] + Global.Item[1]
                          )}
                        </span>
                      ) : (
                        Global.Message
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </SimpleBar>
          </div>

          <div className="col mb-4">
            <h3 className="display-4 mb-2" style={{ fontSize: '1rem' }}>
              Unique Status
            </h3>

            <ul className="list-group HomeList">
              {[
                {
                  Name: 'Tiger Girl',
                  Player: { Name: 'Merlin', Race: 'eu' },
                  Dead: '3h 7m',
                },
                { Name: 'Cerberus', Alive: '1m 3s' },
                {
                  Name: 'Captain Ivy',
                  Player: { Name: 'FR_Henry', Race: 'ch' },
                  Dead: '35m',
                },
                {
                  Name: 'Uruchi',
                  Player: { Name: 'edjka1985', Race: 'ch' },
                  Dead: '4m',
                },
                {
                  Name: 'Isyutaru',
                  Player: { Name: 'Asviix', Race: 'eu' },
                  Dead: '30m',
                },
                { Name: 'Lord Yarkan', Alive: '7m 32s' },
                {
                  Name: 'Demon Shaitan',
                  Player: { Name: 'Nozich', Race: 'ch' },
                  Dead: '2h 21m',
                },
              ].map((Unique, UniqueIndex) => (
                <li
                  className="list-group-item d-flex justify-content-between align-items-center"
                  key={UniqueIndex}
                >
                  {Unique.Name}

                  {Unique.Dead ? (
                    <span className="badge badge-light">
                      <span>
                        <img
                          src={Unique.Player.Race === 'ch' ? RageCH : RageEU}
                          alt="Race"
                          className="mr-2"
                        />

                        <NavLink
                          to={`/Players/${Unique.Player.Name}`}
                          className="text-body text-nowrap"
                        >
                          {Unique.Player.Name}
                        </NavLink>

                        {` ${Unique.Dead} ago`}
                      </span>
                    </span>
                  ) : (
                    <span className="badge badge-light">
                      <span className="rounded px-1 badge-success font-weight-light">
                        Alive
                      </span>

                      {` ${Unique.Alive} ago`}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="col mb-4">
            <h3 className="display-4 mb-2" style={{ fontSize: '1rem' }}>
              Latest Drops
            </h3>

            <ul className="list-group HomeList">
              {[
                {
                  Race: 'eu',
                  Player: '_AntiFire_',
                  Item: '9DG +7 Polearm - 23:15',
                },
                {
                  Race: 'eu',
                  Player: 'Asviix',
                  Item: '8DG +5 [Sun] Staff - 23:15',
                },
                {
                  Race: 'ch',
                  Player: 'MasterForce',
                  Item: '8DG +7 [Som] Tiger Blade - 23:15',
                },
                {
                  Race: 'eu',
                  Player: 'Milaa',
                  Item: '9DG +3 Capricorn - 23:15',
                },
                {
                  Race: 'ch',
                  Player: 'QuieTScr3aM',
                  Item: '9DG +3 Heavy Flame Spear - 23:15',
                },
                {
                  Race: 'eu',
                  Player: '_VulpiX_',
                  Item: '9DG +5 Tigris Mail - 23:15',
                },
                {
                  Race: 'eu',
                  Player: 'Preach',
                  Item: '9DG +1 Tigris Boot - 23:15',
                },
                {
                  Race: 'ch',
                  Player: 'FR_Henry',
                  Item: 'Pirate Accessory (F) - 23:15',
                },
              ].map((Drop, DropIndex) => {
                return (
                  <li
                    className="list-group-item d-flex justify-content-between"
                    key={DropIndex}
                  >
                    <span>
                      <img
                        src={Drop.Race === 'ch' ? RageCH : RageEU}
                        alt={`${
                          Drop.Race === 'ch' ? 'Chinese' : 'Europe'
                        } Character`}
                        className="mr-2"
                      />

                      <NavLink
                        to={`/Players/${Drop.Player}`}
                        className="text-body text-nowrap"
                      >
                        {Drop.Player}
                      </NavLink>
                    </span>

                    <span className="badge badge-light">{Drop.Item}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <SroFilterMenuDialog />
      </div>
    );
  }
}
